import { gql } from 'apollo-boost';
const removeSegment = gql `
	mutation ($seg_id: String!) {
		deleteSegment(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const removeMixedSegment = gql `
	mutation ($seg_id: String!) {
		deleteMixedSegment(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const removeSegmentFromAdForm = gql `
	mutation ($seg_id: String!) {
		deleteSegmentFromAdform(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const importSegmentToAdForm = gql `
	mutation ($seg_id: String!) {
		importSegmentToAdform(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const removeMixedSegmentFromAdForm = gql `
	mutation ($seg_id: String!) {
		deleteMixedSegmentFromAdform(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const importMixedSegmentToAdForm = gql `
	mutation ($seg_id: String!) {
		importMixedSegmentToAdform(segmentId: $seg_id) {
			ok
			message
		}
	}
`;
const getMixSegmentsQuery = gql `
	{
		getMixSegments {
			id
			name
			combined
			firstRun
			sendToAdForm
		}
	}
`;
const getSegmentsQuery = gql `
	{
		segments {
			id
			name
			interests
			operator
			certainty
			sendToAdForm
			defaultInterests
			certaintyDefaultInterests
			income
			certaintyIncome
			firstRun
			lookalikeId
			lookalikeCertainty
			interestOperator
			socDemo {
				id
				name
				certainty
				ageGroups
				isAgeGroup18Plus
				isAgeGroup18Minus
				gender
			}
			targetId
		}
	}
`;
const getLastSegmentQuery = gql `
	{
		lsegment {
			segmentIntId
		}
	}
`;
const copySegment = gql `
	mutation ($id: String!, $name: String!) {
		duplicateSegment(id: $id, name: $name) {
			ok
			copiedSegment {
				id
				name
			}
		}
	}
`;
const GET_COOKIES_QUERY = gql `
	query (
		$confidence: Float
		$socDemoConfidence: Float
		$ageGroups: [String]
		$interestOne: Int!
		$interestTwo: Int
		$newInterest: [String]
		$newConfidence: Float
		$interestsOperator: InterestsOperatorEnum
		$gender: GenderEnum
		$income: [String]
		$incomeConf: Float
		$isLookalike: Boolean
		$lookalikeConf: Float
		$basicInterestOperator: InterestsOperatorEnum
	) {
		cookieCount(
			confidence: $confidence
			socDemoConfidence: $socDemoConfidence
			ageGroups: $ageGroups
			interest: $interestOne
			interest2: $interestTwo
			newInterests: $newInterest
			newConfidence: $newConfidence
			interestsOperator: $interestsOperator
			gender: $gender
			income: $income
			incomeConf: $incomeConf
			isLookalike: $isLookalike
			lookalikeConf: $lookalikeConf
			basicInterestOperator: $basicInterestOperator
		)
	}
`;
const GET_MIX_COOKIES_QUERY = gql `
	query ($queryBuild: [String]) {
		mixCookieCount(queryBuild: $queryBuild)
	}
`;
const createMixedSegment = gql `
	mutation ($name: String!, $combined: JSONString!, $sendToAdForm: Boolean!, $fee: Decimal!) {
		createMixedSegment(
			input: { name: $name, combined: $combined, fee: $fee, sendToAdForm: $sendToAdForm }
		) {
			ok
			segment {
				id
				name
			}
		}
	}
`;
const getTargetsQuery = gql `
	{
		trackings {
			id
			tpName
			tpId
		}
	}
`;
const createSegmentsQuery = gql `
	mutation (
		$name: String!
		$certainty: Float!
		$sendToAdForm: Boolean!
		$fee: Decimal!
		$interests: JSONString!
		$operator: String
		$gender: String
		$ageGroups: JSONString!
		$is_age_group_18_plus: Boolean!
		$is_age_group_18_minus: Boolean!
		$socDemoConfidence: Float!
		$income: JSONString!
		$certainty_income: Float!
		$default_interests: JSONString!
		$certainty_default_interests: Float!
		$target_id: Int
		$lookalike_id: String!
		$lookalike_certainty: Float!
		$interest_operator: String!
	) {
		createSegment(
			input: {
				name: $name
				certainty: $certainty
				sendToAdForm: $sendToAdForm
				fee: $fee
				interests: $interests
				operator: $operator
				gender: $gender
				ageGroups: $ageGroups
				isAgeGroup18Plus: $is_age_group_18_plus
				isAgeGroup18Minus: $is_age_group_18_minus
				socioCertainty: $socDemoConfidence
				income: $income
				certaintyIncome: $certainty_income
				defaultInterests: $default_interests
				certaintyDefaultInterests: $certainty_default_interests
				targetId: $target_id
				lookalikeId: $lookalike_id
				lookalikeCertainty: $lookalike_certainty
				interestOperator: $interest_operator
			}
		) {
			ok
			message
			segment {
				id
				name
			}
		}
	}
`;
export { removeSegment, removeMixedSegment, removeMixedSegmentFromAdForm, importMixedSegmentToAdForm, removeSegmentFromAdForm, importSegmentToAdForm, getSegmentsQuery, getMixSegmentsQuery, copySegment, GET_COOKIES_QUERY, GET_MIX_COOKIES_QUERY, createMixedSegment, getTargetsQuery, createSegmentsQuery, getLastSegmentQuery };
